import React from 'react'
import AboutCards from '../AboutCards'
import Footer from '../Footer';

function AboutMe2() {
  return (
    <>
    <AboutCards/>
    <Footer/>
    </>
  )
}

export default AboutMe2